// src/services/ModuleFreshnessService.js
// Tracks "last modified" timestamps per module, scoped per entity.
// Services call markModified(moduleName) on meaningful data-save operations.
// The Dashboard reads getLastModified(moduleName) to show accurate freshness
// indicators instead of inferring from audit logs (which include read-time
// side effects and miss some save paths).
import storage from './StorageAdapter';
import entityService from './EntityService';

const BASE_KEY = 'module_freshness';

class ModuleFreshnessService {
  constructor() {
    this.listeners = [];
  }

  _entityKey() {
    const entityId = entityService.getActiveEntityId();
    return entityId ? `${BASE_KEY}_${entityId}` : BASE_KEY;
  }

  _read() {
    return storage.getJSON(this._entityKey(), {});
  }

  async markModified(moduleName) {
    const current = this._read();
    current[moduleName] = new Date().toISOString();
    await storage.setJSON(this._entityKey(), current);
    this.notifyListeners();
  }

  getLastModified(moduleName) {
    const current = this._read();
    return current[moduleName] || null;
  }

  getAll() {
    return this._read();
  }

  subscribe(listener) {
    this.listeners.push(listener);
    return () => {
      this.listeners = this.listeners.filter(l => l !== listener);
    };
  }

  notifyListeners() {
    this.listeners.forEach(l => l());
  }
}

const moduleFreshnessService = new ModuleFreshnessService();
export default moduleFreshnessService;
